<template>
	<Link v-if="item.link && (item.visible === undefined || item.visible === true)" :href="item.link ?? ''" :class="`px-2 py-1 rounded whitespace-nowrap ${isActive(item.id) ? 'bg-gray-200 dark:bg-gray-800' : 'hover:bg-gray-200 dark:hover:bg-gray-800'}`">{{ trans(item.title) }}</Link>
	<template v-else-if="item.children.length > 0">
		<button type="button" class="px-2 py-1 rounded flex items-center gap-3 text-xs hover:bg-gray-200 dark:hover:bg-gray-800 text-true-aareii-600 dark:text-blue-300" @click.stop="toggleChildren">
			<span class="grow text-left font-bold uppercase whitespace-nowrap">{{ trans(item.title) }}</span>
			<i v-if="open" class="fa-solid fa-chevron-up"/>
			<i v-else class="fa-solid fa-chevron-down"/>
		</button>
		<div v-if="open" class="pl-2 border-l border-gray-200 dark:border-gray-800 flex flex-col gap-1">
			<MenuItem v-for="child in item.children" :item="child"/>
		</div>
	</template>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import {Link, usePage} from '@inertiajs/vue3'
import {type MenuItem} from '@/Types/Components/Menu/MenuItem'
import {ref, type Ref, computed, type ComputedRef, defineProps} from 'vue'

const props = defineProps<{
	item:MenuItem,
}>()

const page = usePage()

const currentRouteName:ComputedRef<string> = computed(():string => page.props.currentRouteName)

const item:Ref<MenuItem> = ref(props.item)
const open:Ref<boolean> = ref(hasSelectedChild(item.value))

function toggleChildren():void{
	open.value = !open.value
}

function hasSelectedChild(item:MenuItem):boolean{
	let found = false
	if(item.children){
		for(let i:number = 0; !found && i < item.children.length; i++){
			found = (item.children[i].children && item.children[i].children.length > 0) ? hasSelectedChild(item.children[i]) : isActive(item.children[i].id)
		}
	}
	return found
}

function isActive(id:string):boolean{
	return currentRouteName.value.startsWith(id)
}
</script>